import React from 'react';

import { RequestStatus } from '../../../../utils/wrapRequest';
import { useOnlineOrdersStorage } from '../../storage';
import DispatchInfo from '../DispatchInfo';
import { FulfillmentPicker } from '../FulfillmentPicker';

import { classes, st } from './FulfillmentSection.st.css';
import { fulfillmentSectionDataHooks } from './constants';

const FulfillmentSection: React.FC = () => {
  const {
    fulfillmentMethods,
    fetchFulfillmentMethodsStatus,
    operations,
    isLocationSelected,
  } = useOnlineOrdersStorage();

  const isGhostMode = operations.length > 1 && !isLocationSelected;
  const isFulfillmentMethodsResolved =
    fetchFulfillmentMethodsStatus === RequestStatus.RESOLVED;
  const hasEnabledFulfillmentMethod = fulfillmentMethods.some(
    (method) => method.enabled,
  );

  if (isGhostMode) {
    return null;
  }

  if (isFulfillmentMethodsResolved && !hasEnabledFulfillmentMethod) {
    return null;
  }

  return (
    <div
      data-hook={fulfillmentSectionDataHooks.root()}
      className={st(classes.root)}
    >
      <FulfillmentPicker />
      <DispatchInfo />
    </div>
  );
};

export default FulfillmentSection;
